import {VideoPlayerBaseModel} from "../video-player-base.model";
import {IVideoPlayerStrategy} from "../video-player.strategy.interface";
import {NativeVideoStreamingStrategy} from "./strategies/native-video-streaming.strategy";
import {HlsVideoStreamingStrategy} from "./strategies/hls-video-streaming.strategy";



export class VideoStreamingPlayerModel extends VideoPlayerBaseModel {
    protected _createPlayerStrategy(): IVideoPlayerStrategy {
        if(!this.services.device.os.isAndroid && this.services.video.isNativeStreamingSupported(this.videoElement)) {
            return new NativeVideoStreamingStrategy(this.videoElement);
        }

        return new HlsVideoStreamingStrategy(this.videoElement);
    }

}